<ng-container *transloco="let t">
  <ld-base-modal [title]="t('commonLabelsSuccess')" [showCloseButton]="false" (closeModal)="cancel.emit()">
    <div modal-content>
      @if (bankLogo() || bankName()) {
        <div class="flex items-center gap-3 mb-4 pb-4 border-b border-ld-neutral-200">
          @if (bankLogo()) {
            <img [src]="bankLogo()" [alt]="bankName()" class="h-8 w-auto object-contain" />
          } @else {
            <mat-icon class="text-ld-primary text-2xl!">account_balance</mat-icon>
          }
          <p class="font-dm font-medium text-ld-neutral">{{ bankName() }}</p>
        </div>
      }

      <div class="space-y-3">
        @for (account of linkedAccounts(); track account.accountId; let i = $index) {
          <div [id]="'linked-account-' + i" class="flex items-center gap-3 p-3 rounded-xl bg-ld-neutral-50">
            <div class="size-10 rounded-lg bg-white flex items-center justify-center shrink-0 shadow-sm">
              <mat-icon class="text-ld-primary text-xl!">account_balance</mat-icon>
            </div>

            <div class="flex-1 min-w-0">
              <p class="font-dm text-sm font-medium text-ld-neutral truncate">
                {{ account.nickName || account.accountNumber || 'Account' }}
              </p>
              <p class="font-dm text-xs text-ld-neutral-500">
                {{ account.institutionName || 'Account' }}
                @if (account.accountNumber) {
                  <span class="ml-1">•••{{ account.accountNumber | slice: -4 }}</span>
                }
              </p>
            </div>

            <div class="text-right shrink-0">
              <p class="font-dm text-sm font-semibold text-ld-neutral">
                {{ account.balance | currency: 'USD' : 'symbol' : '1.2-2' }}
              </p>
            </div>
          </div>
        }
      </div>

      <div class="mt-4 pt-4 border-t border-ld-neutral-200 flex items-center justify-between">
        <p class="font-dm text-sm font-medium text-ld-neutral-500">Total Assets Added</p>
        <p class="font-dm text-xl font-bold text-ld-primary">
          {{ totalBalance() | currency: 'USD' : 'symbol' : '1.2-2' }}
        </p>
      </div>

      <p class="font-dm text-xs text-ld-neutral-400 text-center mt-4">
        {{ t('modalsAssetSummaryDisclaimer') }}
      </p>
    </div>
    <div modal-footer>
      <button
        id="asset-summary-done-btn"
        type="button"
        class="btn-primary-ld-purple"
        [disabled]="isLoading()"
        (click)="onDone()"
      >
        @if (isLoading()) {
          <mat-spinner diameter="16" class="w-4! h-4! [&_circle]:stroke-white!"></mat-spinner>
          Finishing...
        } @else {
          {{ t('commonButtonsDone') }}
        }
      </button>

      <button
        id="asset-summary-add-more-btn"
        type="button"
        class="btn-outline-ld-purple"
        [disabled]="isLoading()"
        (click)="onAddMore()"
      >
        {{ t('modalsAssetSummaryAddMoreButton') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
